import { useContext } from "react";
import { hideModal } from "../../../context/Actions/modal/modal";
import { PortalContext } from "../../../context/Provider";
import "./DeteccionNavegador.css";
const DeteccionNavegador = () => {
  const { modalDispatch, textosState } = useContext(PortalContext);

  const dismmiss = () => {
    hideModal()(modalDispatch);
  };

  return (
    <div className="ptur-deteccionNavegador-container noSeleccionable">
      <div className="ptur-deteccionNavegador-header bgcG-latex30">
        <span className="rb18m c-white">Información</span>
      </div>
      <div className="ptur-deteccionNavegador-body">
        {textosState.textos.data && (
          <span className="ptur-deteccionNavegador-txt rb18m">
            {textosState.textos.data.msjNavegadorChrome
              ? textosState.textos.data.msjNavegadorChrome.descripcion
              : "Error"}
          </span>
        )}
        <div className="ptur-deteccionNavegador-botones">
          <button className="btn bgc-primary" onClick={dismmiss}>
            <span className="rb18m c-white">Aceptar</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeteccionNavegador;
